import { types } from './actions';

const initialState = {
  supplierFacilities: [],
  isLoading: false,
  isSupplierFacilityDrawerOpen: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.SUPPLIER_FACILITIES_FETCH_SUCCESS:
      return {
        ...state,
        supplierFacilities: payload.supplierFacilities,
      };
    case types.UPDATE_SUPPLIER_FACILITY_ERROR:
      return state;
    case types.UPDATE_SUPPLIER_FACILITY_REQUEST:
      return state;
    case types.UPDATE_SUPPLIER_FACILITY_SUCCESS:
      return state;
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.company.supplierFacilities.settingsPage;

export const getIsLoading = (state) => getScope(state).isLoading;
export const getSupplierFacilities = (state) =>
  getScope(state).supplierFacilities;

export const getDefaultFacility = (state) =>
  getScope(state).supplierFacilities.find(
    (facility) => facility.isDefault === true,
  );
